function setPopupCookie(cname) {
    const d = new Date();
    const expiresInDays = 7; // Expiry in days
    const cvalue = '1'; // Value but not important
    d.setTime(d.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires}`;
}

function checkCookie() {
    document.cookie = 'testcookie';
    const cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    return cookieEnabled;
}

document.addEventListener('DOMContentLoaded', () =>{
    const newsletterModal = document.querySelector('#newsletter-modal');
    const newsletterModalClose = newsletterModal.querySelector('.newsletter-modal__close');
    const cookieName = 'auto-newsletter-popup';

    if(newsletterModal){

        //Setup a query for newsletter demo
        const urlParams = new URLSearchParams(window.location.search);
        const isNewsletterDemo = urlParams.get('nldemo');

        if(newsletterModalClose){
            newsletterModalClose.addEventListener('click', function(e){
                newsletterModal.close();
            })
        }

        //Attempt to add cookie
        setTimeout(() => {
            if(checkCookie() || isNewsletterDemo){
                if(document.cookie.indexOf(cookieName) === -1 || isNewsletterDemo){
                    newsletterModal.open();
                    setPopupCookie(cookieName);
                }
            }
        }, isNewsletterDemo ? 1000 : 10000);
    }


    
})
  